import type { JSX } from 'react';

import { Text, ThemeProvider } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';

export function Footer(): JSX.Element {
	return (
		<ThemeProvider>
			<Box sx={{ textAlign: 'center', font: 'body', mt: 12, mx: 8 }}>
				<Text variant="body" data-qa="ppmu-modal-footer-text" size="small" fontWeight="normal">
					<Translate value="corgi.co.ppmu.modal.footer_text" />
				</Text>
			</Box>
		</ThemeProvider>
	);
}
